import React from 'react';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import FastFilter from 'src/ui/library/FastFilter';
import Grid from '@material-ui/core/Grid';

function LandingFastFilter({ filters, history, trackClickAnalytics, onChange }) {
  return (
    <div className="landing-fastfilter-container">
      <Grid container className="fastfilter">
        <Grid item className="fastfilter-back-btn" lg={1} md={1} sm={1} xs={1}>
          <HistoryDisplayContainer history={history} trackClickAnalytics={trackClickAnalytics} />
        </Grid>
        <Grid item lg={11} md={11} sm={11} xs={11}>
          <FastFilter filters={filters} onChange={onChange} />
        </Grid>
      </Grid>
    </div>
  );
}

export default LandingFastFilter;
